import Auth from "@/store/Auth";

export default () => Auth.state.authentication;
